module.exports = __webpack_public_path__ + "static/media/mvp.67b44398.png";